import { Box, type BoxProps } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

type MotionFadeProps = BoxProps & {
  delay?: number;
};

export function MotionFade({ children, delay = 0, ...props }: MotionFadeProps) {
  return (
    <MotionBox
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-72px" }}
      transition={{
        duration: 0.55,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
      {...props}
    >
      {children}
    </MotionBox>
  );
}
